import vendor from './vendor'
import { token } from './token.js'
import helpers from './helpers.js'
import { events } from './event-bus.js'

export default Object.assign(helpers, {
  install (Vue, {axios, echo, vds}) {
    // Init the token manager
    token.init({axios})

    // Sync vendor to token manager
    vendor.axios.configure(axios, token)
    vendor.echo.configure(echo, token, axios, vds)

    // Export this instance to vue
    Vue.prototype.$nexus = this

    // Handle events
    token.on('changed', (token) => {
      if(token === null) {
        events.emit('disconnected')
      }
    })

    // Remember instances for accessors
    this.token = token
    this.axios = axios
    this.echo = echo
  },
  login (email, password) {
    return this.token.retrieve(email, password)
  },
  logout () {
    this.token.forget()
    return Promise.resolve()
  },
  getToken () {
    return this.token.get()
  },
  setToken (token) {
    return this.token.set(token)
  },
  hasToken () {
    return this.token.isset()
  },
  on (event, method) {
    return events.on(event, method)
  },
  get (endpoint, url, config) {
    return this.axios.get(helpers.url(endpoint, url), config)
  },
  delete (endpoint, url, config) {
    return this.axios.delete(helpers.url(endpoint, url), config)
  },
  post (endpoint, url, data, config) {
    return this.axios.post(helpers.url(endpoint, url), data, config)
  },
  put (endpoint, url, data, config) {
    return this.axios.put(helpers.url(endpoint, url), data, config)
  },
  patch (endpoint, url, data, config) {
    return this.axios.patch(helpers.url(endpoint, url), data, config)
  }
})



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/index.js